import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { isChineseSite } from './utils'

import translationZH from './locales/zh/translation.json'
import translationEN from './locales/en/translation.json'

export const SUPPORTED_LANGUAGES = [
  {
    code: 'zh',
    name: '中文简体'
  },
  {
    code: 'en',
    name: 'English'
  }
]

const resources = {
  zh: {
    translation: translationZH
  },
  en: {
    translation: translationEN
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      convertDetectedLanguage: (lng) => lng.split('-')[0].split('_')[0],
      supportedLngs: SUPPORTED_LANGUAGES.map(item => item.code)
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      wait: true
    }
  }, () => {
    document.documentElement.lang = i18n.language || 'zh';
  });

i18n.isEnglish = () => i18n.language === 'en'

if (isChineseSite()) {
  i18n.changeLanguage('zh')
}

export default i18n;
